module.exports = __webpack_public_path__ + "img/thank_you.708c3549.png";